import { useEffect } from 'react'

import { decideActionPermission } from '@editor/services/Validation'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { reset, setPermissionSet } from '../store/editor'

export const useEditor = () => {
  // Store
  const dispatch = useAppDispatch()
  const isLoading = useSelector((state: RootState) => state.page.isLoading)
  const isInvited = useSelector((state: RootState) => state.page.isInvited)
  const isOwner = useSelector((state: RootState) => state.page.isOwner)
  const userProfile = useSelector((state: RootState) => state.user.userProfile)

  /**
   * Get permission set for the Editor
   */
  useEffect(() => {
    if (isLoading || !userProfile) return

    dispatch(setPermissionSet(decideActionPermission(isOwner, isInvited, userProfile.owned_products).EDITOR))
  }, [isLoading, isInvited, isOwner, userProfile, dispatch])

  /**
   * Reset store when unmounting
   */
  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch],
  )
}
